<div class="row mt-3">
  <div class="col-12">
    @if (loading) {
      <div class="text-center my-3">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </div>
    }

    @if (banners && banners.length > 0 && !loading) {
      <div class="banner-carousel-container">
        <div
          #carouselElement
          id="bannerCarousel"
          class="carousel slide carousel-animation"
          [class.no-animation]="banners.length <= 1"
          [attr.data-bs-ride]="banners.length > 1 ? 'carousel' : null"
          [attr.data-bs-interval]="banners.length > 1 ? '7000' : 'false'"
          data-bs-pause="false"
        >
          @if (banners.length > 1) {
            <div class="carousel-indicators">
              @for (banner of banners; track banner; let i = $index) {
                <button
                  type="button"
                  [attr.data-bs-target]="'#bannerCarousel'"
                  [attr.data-bs-slide-to]="i"
                  [class.active]="i === 0"
                  [attr.aria-current]="i === 0 ? 'true' : null"
                  [attr.aria-label]="'Slide ' + (i + 1)"
                ></button>
              }
            </div>
          }
          <div class="carousel-inner">
            @for (banner of banners; track banner; let i = $index) {
              <div class="carousel-item" [class.active]="i === 0" [attr.data-index]="i">
                @if (banner.url) {
                  <a [href]="getProperUrl(banner.url)" target="_blank">
                    <img
                      [src]="banner.imageUrl"
                      class="d-block w-100"
                      [alt]="banner.description || 'Banner'"
                      (load)="adjustCarouselHeight()"
                    />
                  </a>
                }
                @if (!banner.url) {
                  <img
                    [src]="banner.imageUrl"
                    class="d-block w-100"
                    [alt]="banner.description || 'Banner'"
                    (load)="adjustCarouselHeight()"
                  />
                }
              </div>
            }
          </div>
          @if (banners.length > 1) {
            <button class="carousel-control-prev" type="button" (click)="manualPrev($event)" aria-label="Previous">
              <span class="carousel-control-prev-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" (click)="manualNext($event)" aria-label="Next">
              <span class="carousel-control-next-icon" aria-hidden="true"></span>
              <span class="visually-hidden">Next</span>
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>
